var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('file-upload'),_c('v-text-field',{attrs:{"label":"Path"},model:{value:(_vm.path),callback:function ($$v) {_vm.path=$$v},expression:"path"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }